import Vue from 'vue';
import App from './app.vue';
import ViewUI from 'view-design';
import { router } from './router/index';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Ajax from './lib/ajax';
import Util from './lib/util';
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
Vue.use(ViewUI);
import store from './store/index';
Vue.config.productionTip = false;
import axios from 'axios'
import { appRouters, otherRouters } from './router/router';
import appconst from './lib/appconst';
if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
  let language = navigator.language;
  abp.utils.setCookieValue('Abp.Localization.CultureName', language, new Date(new Date().getTime() + 5 * 365 * 86400000), abp.appPath);
}

axios.create = function () {
  return axios;
}

axios.defaults.headers.common['Authorization'] = "Bearer " + window.abp.auth.getToken();
axios.defaults.baseURL = appconst.remoteServiceBaseUrl;
let vm = new Vue({});
axios.interceptors.request.use(function (config) {
  // var spin= vm.$Spin as any;
  // spin.show();
  return config;
}, function (error) {
  return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  // var spin= vm.$Spin as any;
  // spin.hide();  
  response.data = response.data.result;
  return response;
}, function (error) {
  var spin = vm.$Spin as any;
  // spin.hide();  
  setTimeout(() => {
    if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
      vm.$Modal.error({ title: error.response.data.error.message, content: error.response.data.error.details })
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
      vm.$Modal.error({ title: window.abp.localization.localize("LoginFailed"), content: error.response.data.error.message })
    } else if (!error.response) {
      vm.$Modal.error(window.abp.localization.localize('UnknownError'));
    }
  }, 500);//这个地方必须 加延迟   不然弹窗会一闪而过  
  setTimeout(() => {
    vm.$Message.destroy();
  }, 1000);
  return Promise.reject(error);

});


Ajax.get('/AbpUserConfiguration/GetAll').then(data => {
  Util.abp = Util.extend(true, Util.abp, data.data.result);
  Ajax.post('/api/services/app/Common/QuerySystemSetting').then(x => {
    let a = Util.abp as any;
    a.system = x.data.result;

    new Vue({
      render: h => h(App),
      router: router,
      store: store,
      data: {
        currentPageName: ''
      },
      async mounted() {
        this.currentPageName = this.$route.name as string;
        await this.$store.dispatch({
          type: 'session/init'
        })
        if (!!this.$store.state.session.user && this.$store.state.session.application.features['SignalR']) {
          if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
            SignalRAspNetCoreHelper.initSignalR();
          }
        }
        this.$store.commit('app/initCachepage');
        this.$store.commit('app/updateMenulist');
      },
      created() {
        let tagsList: Array<any> = [];
        appRouters.map((item) => {
          if (item.children.length <= 1) {
            tagsList.push(item.children[0]);
          } else {
            tagsList.push(...item.children);
          }
        });
        this.$store.commit('app/setTagsList', tagsList);
      }
    }).$mount('#app')
  })
  
})

